<template>
  <!--
    Home.vue
    Dashboard view showing daily and overall statistics.
    Features:
      - DailyStat and OverallStat components
      - Year filter for overall stats
      - Uses Vuetify layout
  -->
  <v-container>
    <v-row>
      <v-col cols="12">
        <!-- Daily statistics section -->
        <p class="text-overline font-weight-black mb-2">Daily Statistics</p>
        <v-row>
          <v-col>
            <daily-stat :is-loading="isLoading" :count="stats.todayApprovedApplicants" title="Today Approved" icon="mdi-check-circle" color="success"></daily-stat>
          </v-col>
          <v-col>
            <daily-stat :is-loading="isLoading" :count="stats.todayDeclinedApplicants" title="Today Declined" icon="mdi-close-circle" color="error"></daily-stat>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <!-- Overall statistics section with year filter -->
        <div class="d-flex justify-space-between align-center mb-6">
          <v-row>
            <v-col cols="10">
              <p class="text-overline font-weight-black mb-2">Overall Statistics</p>
            </v-col>
            <v-col cols="2">
              <v-menu top close-on-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn id="selectedYear" color="primary" dark v-bind="attrs" v-on="on">
                    <v-icon left>mdi-calendar-badge</v-icon>
                    Filter: {{ selectedOverallStatsYear }}
                    <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(year, index) in years" :key="index">
                    <v-btn class="text-body-2 select-year-button" :class="{ 'blue--text text--darken-3': year === selectedOverallStatsYear }" text @click="getTotalStatsForYear(year)">
                      {{ year }}
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
        <overall-stat :is-loading="isLoading" :items="totalStats"></overall-stat>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Home.vue: dashboard view for statistics
import { getStatisticsByYear } from '@/services';
import DailyStat from '@/components/Home/DailyStat';
import OverallStat from '@/components/Home/OverallStat';

export default {
  name: 'Home',
  components: {
    DailyStat,
    OverallStat,
  },
  data() {
    return {
      // Currently selected year for overall stats
      selectedOverallStatsYear: 'All',
      // List of years for filtering
      years: ['All', 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018],
      // Loading state for stats
      isLoading: true,
      // API endpoint (from env)
      backendEndpoint: process.env.VUE_APP_BACKEND_ENDPOINT,
      // Stats for today and overall
      stats: {
        todayConfirmed: 0,
        todayDeclined: 0,
      },
      // Parsed total stats for table
      totalStats: [],
    };
  },
  async created() {
    await this.getStats();
  },
  methods: {
    /**
     * Parse stats object into array for table
     */
    parseStats() {
      const parsedStats = Object.keys(this.stats).map((key) => ({ stat: key, count: this.stats[key] }));
      this.totalStats = parsedStats.filter((item) => item.stat.includes('total'));
    },
    /**
     * Fetch statistics for the selected year
     */
    async getStats() {
      this.isLoading = true;
      const response = await getStatisticsByYear(this.selectedOverallStatsYear);
      if (response.data) {
        this.stats = response.data;
        this.parseStats();
      }
      this.isLoading = false;
    },
    /**
     * Change year filter and fetch stats
     */
    async getTotalStatsForYear(year) {
      this.selectedOverallStatsYear = year;
      this.totalStats = [];
      await this.getStats();
    },
  },
};
</script>
